/* 劉備傳・第 1 章：安喜縛督郵（中平年間，約 185）
 * 史實：《三國志·先主傳》劉備討黃巾有功，除安喜尉。「督郵以公事到縣，先主求謁，不通，直入縛督郵，杖二百，解綬繫其頸著馬枊，棄官亡命。」
 *       動手的是劉備本人；演義改成張飛鞭督郵（外傳）。
 * 流程：1. 帶關羽、張飛清掉縣城四周的黃巾殘部（入門教學：學技能、排路線、拾獲）。
 *       2. 督郵到縣，求見不通（傳舍的門關著）→ 站在門前撞開，直入；站在督郵旁邊縛住他、杖二百 → 棄官亡命，從東邊離開即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick } from '../kit.ts';
import { TOWN, LODGE, LODGE_GATE, CAMPS, EXIT } from '../maps/anxi.ts';

const LV = 3, START = [2800, 2700];

export default {
  id: 'liubei-1', map: 'anxi', hero: 'liubei', gold: 0,
  title: '第 1 章　安喜縛督郵', year: '中平年間（約 185）',
  brief: {
    quote: [{ text: '督郵以公事到縣，先主求謁，不通，直入縛督郵，杖二百，解綬繫其頸著馬枊，棄官亡命。', src: '《三國志·蜀書·先主傳》' }],
    text: '劉備帶著關羽、張飛討伐黃巾有功，當上了中山安喜縣的縣尉。這時朝廷下詔，要淘汰因軍功當官的人。（演義把「鞭督郵」改成張飛做的，正史是劉備本人。）',
    goals: ['清掉縣城四周的黃巾殘部', '督郵不肯見：直入傳舍，縛督郵', '棄官亡命'],
  },
  words: { ally: '鄉勇', foe: '黃巾' },
  stars: [
    { text: '四處黃巾殘部都清掉', ok: (m) => m.vars.cleared === 4 },
    { text: '學會排路線（Shift＋右鍵）', ok: (m) => !!m.vars.route },
    { text: '拾獲 3 件以上', ok: (m) => m.stats.loot >= 3 },
  ],
  steps: [
    { // 1. 清黃巾殘部
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.guan = ally(w, 'guanyu', me.x - 100, me.y + 80, LV); V.zhang = ally(w, 'zhangfei', me.x - 100, me.y - 80, LV);
        V.camps = CAMPS.map(([x, y], k) => { m.mark('c' + k, x, y, '黃巾殘部', true); return m.camp(x, y, [['huangjin', 4]], 160); });
        V.cleared = 0;
        for (const [x, y, kind, o] of [[1900, 1900, 'gold', { n: 60 }], [1700, 3100, 'item', { id: 'jinchuang' }], [5900, 1600, 'book', { n: 200 }], [6200, 3100, 'gold', { n: 80 }], [3300, 3500, 'food', { n: 0.5 }]]) m.loot(x, y, kind, o);
        m.line('劉備', '雲長、翼德，縣城四周還有黃巾殘部，掃清了再說。');
        m.after(4, () => m.line('提示', '按 Alt＋Q／W／E 學技能。按住 Shift 再按右鍵可以排好幾個路點，劉備會照順序走過去。'));
        if (!w.campaign.touch) m.obj('route', '用 Shift＋右鍵排一條路線（3 個點）');
        m.obj('clear', '清掉黃巾殘部', 4);
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        const r = m.get('route'); if (r && !r.done && me.input.wp && me.input.wp.length >= 2) { m.done('route'); V.route = true; }
        V.cleared = V.camps.filter((c, k) => { const done = c.every((u) => !u.alive); if (done) m.unmark('c' + k); return done; }).length;
        m.prog('clear', V.cleared);
        return V.cleared >= 4 || m.t > 240; // 清不完也不卡關
      },
    },
    { // 2. 督郵到縣：求謁不通
      enter(m, w) {
        const V = m.vars;
        m.done('clear'); if (m.get('route') && !m.get('route').done) m.drop('route');
        m.gate('lodge', LODGE_GATE[0], LODGE_GATE[1], 110, 'citygate', ['門吏', '督郵大人有公事，誰都不見！']);
        V.du = m.folk(LODGE.x, LODGE.y - 40, { name: '督郵', still: true, near: 1, look: 2 });
        m.line('縣吏', '劉縣尉，督郵到了，說是要淘汰因軍功當官的人……');
        m.after(3, () => m.line('劉備', '我去求見他。'));
        m.mark('lodge', LODGE_GATE[0], LODGE_GATE[1] + 80, '傳舍');
        m.obj('in', '求見督郵');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (!V.refused && m.near(me, LODGE_GATE[0], LODGE_GATE[1] + 80, 200)) { V.refused = true; m.card('督郵以公事到縣，先主求謁，不通。', '《先主傳》'); m.after(2, () => m.line('張飛', '大哥，他這是看不起咱們！')); m.after(4, () => m.line('提示', '站在門前不動，就能撞開傳舍的門。')); }
        if (V.refused) m.chanAt(me, 'door', LODGE_GATE[0], LODGE_GATE[1] + 80, 160, 2, '撞門', () => { V.broke = true; });
        return !!V.broke;
      },
    },
    { // 3. 直入縛督郵
      enter(m, w) {
        const V = m.vars;
        m.done('in'); m.unmark('lodge');
        m.ungate('lodge');
        m.line('劉備', '督郵何在！');
        m.obj('bind', '縛督郵、杖二百');
        m.mark('du', V.du.x, V.du.y, '督郵', true);
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        m.chanAt(me, 'bind', V.du.x, V.du.y + 40, 140, 3, '縛督郵', () => { V.bound = true; V.du.lying = true; V.du.cloth = '#6a5a4a'; });
        return !!V.bound;
      },
    },
    { // 4. 棄官亡命
      enter(m) {
        m.done('bind'); m.unmark('du');
        m.card('直入縛督郵，杖二百，解綬繫其頸著馬枊，棄官亡命。', '《先主傳》');
        m.after(3, () => m.line('劉備', '這官不做也罷。走！'));
        m.mark('exit', EXIT[0], EXIT[1], '亡命');
        m.obj('exit', '棄官亡命：從東邊離開');
      },
      tick(m, w) {
        if (!m.near(w.player, EXIT[0], EXIT[1], 300)) return false;
        m.done('exit');
        m.after(2, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('劉備陣亡'); return; }
    const V = m.vars;
    if (V.guan) { allyTick(w, V.guan, w.player); allyTick(w, V.zhang, w.player); }
  },
};
